import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi, useQueryApi } from "api/hooks.ts";
import queryClient from "api/queryClient.ts";
import { offerCustomFieldApi } from "api/TenantSlug/OfferCustomFields/api.ts";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

import GetOfferCustomFieldsRequest = App.Http.Requests.Offer.GetOfferCustomFieldsRequest;
import GetOfferCustomFieldResponse = App.Http.Responses.Offer.GetOfferCustomFieldResponse;
import StoreOfferCustomFieldRequest = App.Http.Requests.Offer.StoreOfferCustomFieldRequest;
import GetOfferCustomFieldRequest = App.Http.Requests.Offer.GetOfferCustomFieldRequest;
import UpdateOfferCustomFieldRequest = App.Http.Requests.Offer.UpdateOfferCustomFieldRequest;

export const useGetOfferCustomFields = (offerId: string, request: GetOfferCustomFieldsRequest) => {
    return useQueryApi({
        queryKey: ["getOfferCustomFields", offerId, request],
        queryFn: () => offerCustomFieldApi.index(offerId, request),
    })
}

export const useGetOfferCustomField = (offerId: string, fieldId: string, request: GetOfferCustomFieldRequest, enabled?: boolean) => {
    return useQueryApi({
        queryKey: ["getOfferCustomField", offerId, fieldId, request],
        queryFn: () => offerCustomFieldApi.show(offerId, fieldId, request),
        enabled,
    })
}

export const useStoreOfferCustomField = (offerId: string, options: UseMutationOptions<GetOfferCustomFieldResponse, AxiosError<ApiErrorResponse>, StoreOfferCustomFieldRequest>) => {
    return useMutationApi({
        mutationKey: ["storeOfferCustomField"],
        mutationFn: (request: StoreOfferCustomFieldRequest) => offerCustomFieldApi.store(offerId, request),
        ...options,
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
            return queryClient.invalidateQueries({ queryKey: ["getOfferCustomFields", offerId ]});
        },
    });
}
export const useUpdateOfferCustomField = (offerId: string, fieldId: string, options: UseMutationOptions<GetOfferCustomFieldResponse, AxiosError<ApiErrorResponse>, UpdateOfferCustomFieldRequest>) => {
    return useMutationApi({
        mutationKey: ["updateOfferCustomField", offerId, fieldId],
        mutationFn: (request: UpdateOfferCustomFieldRequest) => offerCustomFieldApi.update(offerId, fieldId, request),
        ...options,
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
            return queryClient.invalidateQueries({ queryKey: ["getOfferCustomFields", offerId ]});
        },
    });
}

export const useDestroyOfferCustomField = (offerId: string, fieldId: string, options: UseMutationOptions<void, AxiosError<ApiErrorResponse>, void>) => {
    return useMutationApi({
        mutationKey: ["destroyOfferCustomField", offerId, fieldId],
        mutationFn: () => offerCustomFieldApi.destroy(offerId, fieldId),
        ...options,
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
            return queryClient.invalidateQueries({ queryKey: ["getOfferCustomFields", offerId ]});
        },
    });
}